export const jobCategory = [
  { value: "Full_Time", label: "Full Time" },
  { value: "Part_Time", label: "Part Time" },
  { value: "Full_Time_Part_Time", label: "Full Time and Part Time Available" },
  { value: "Internship", label: "Internship" },
  { value: "Apprenticeship", label: "Apprenticeship" },
];
